"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_native_1 = require("react-native");
var styles = react_native_1.StyleSheet.create({
    dividerContainer: {
        paddingTop: 7,
        paddingBottom: 7,
        zIndex: 0,
    },
    divider: {
        height: '100%',
        width: 1,
        borderWidth: 0,
        backgroundColor: 'rgba(120, 120, 120, 0.2)',
    },
});
exports.default = styles;
//# sourceMappingURL=DividerStyles.js.map